"use strict";

exports.__esModule = true;
var _exportNames = {
  LordIconElement: true,
  BasicAnimation: true,
  ClickAnimation: true,
  HoverAnimation: true,
  AutoAnimation: true,
  LoopAnimation: true,
  MorphAnimation: true,
  MorphTwoWayAnimation: true,
  defineLordIconElement: true
};
exports.defineLordIconElement = defineLordIconElement;
exports.MorphTwoWayAnimation = exports.MorphAnimation = exports.LoopAnimation = exports.AutoAnimation = exports.HoverAnimation = exports.ClickAnimation = exports.BasicAnimation = exports.LordIconElement = void 0;

var _element = require("./main/element.js");

var _basic = require("./animations/basic.js");

var _click = require("./animations/click.js");

var _hover = require("./animations/hover.js");

var _morph = require("./animations/morph.js");

var _morphTwoWay = require("./animations/morph-two-way.js");

var _loop = require("./animations/loop.js");

var _auto = require("./animations/auto.js");

var _colors = require("./helpers/colors.js");

Object.keys(_colors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  exports[key] = _colors[key];
});

var _lottie = require("./helpers/lottie.js");

Object.keys(_lottie).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  exports[key] = _lottie[key];
});
var LordIconElement = _element.Element;
exports.LordIconElement = LordIconElement;
var BasicAnimation = _basic.Basic;
exports.BasicAnimation = BasicAnimation;
var ClickAnimation = _click.Click;
exports.ClickAnimation = ClickAnimation;
var HoverAnimation = _hover.Hover;
exports.HoverAnimation = HoverAnimation;
var AutoAnimation = _auto.Auto;
exports.AutoAnimation = AutoAnimation;
var LoopAnimation = _loop.Loop;
exports.LoopAnimation = LoopAnimation;
var MorphAnimation = _morph.Morph;
exports.MorphAnimation = MorphAnimation;
var MorphTwoWayAnimation = _morphTwoWay.MorphTwoWay;
/**
 * Defines custom element "lord-icon". This methods also register all animations supported by this library.
 * @param loader Animation loader. Provide Lottie.loadAnimation here.
 */

exports.MorphTwoWayAnimation = MorphTwoWayAnimation;

function defineLordIconElement(loader) {
  _element.Element.registerLoader(loader);

  _element.Element.registerAnimation('hover', _hover.Hover);

  _element.Element.registerAnimation('click', _click.Click);

  _element.Element.registerAnimation('morph', _morph.Morph);

  _element.Element.registerAnimation('morph-two-way', _morphTwoWay.MorphTwoWay);

  _element.Element.registerAnimation('loop', _loop.Loop);

  _element.Element.registerAnimation('auto', _auto.Auto);

  customElements.define('lord-icon', _element.Element);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9sb3JkLWljb24tZWxlbWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUdBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQ0E7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUVPLElBQU0sZUFBZSxHQUFHLGdCQUF4Qjs7QUFFQSxJQUFNLGNBQWMsR0FBRyxZQUF2Qjs7QUFDQSxJQUFNLGNBQWMsR0FBRyxZQUF2Qjs7QUFDQSxJQUFNLGNBQWMsR0FBRyxZQUF2Qjs7QUFDQSxJQUFNLGFBQWEsR0FBRyxVQUF0Qjs7QUFDQSxJQUFNLGFBQWEsR0FBRyxVQUF0Qjs7QUFDQSxJQUFNLGNBQWMsR0FBRyxZQUF2Qjs7QUFDQSxJQUFNLG9CQUFvQixHQUFHLHdCQUE3QjtBQUVQOzs7Ozs7O0FBSU0sU0FBVSxxQkFBVixDQUFnQyxNQUFoQyxFQUFvRDtBQUN0RCxtQkFBUSxjQUFSLENBQXVCLE1BQXZCOztBQUVBLG1CQUFRLGlCQUFSLENBQTBCLE9BQTFCLEVBQW1DLFlBQW5DOztBQUNBLG1CQUFRLGlCQUFSLENBQTBCLE9BQTFCLEVBQW1DLFlBQW5DOztBQUNBLG1CQUFRLGlCQUFSLENBQTBCLE9BQTFCLEVBQW1DLFlBQW5DOztBQUNBLG1CQUFRLGlCQUFSLENBQTBCLGVBQTFCLEVBQTJDLHdCQUEzQzs7QUFDQSxtQkFBUSxpQkFBUixDQUEwQixNQUExQixFQUFrQyxVQUFsQzs7QUFDQSxtQkFBUSxpQkFBUixDQUEwQixNQUExQixFQUFrQyxVQUFsQzs7QUFFQSxFQUFBLGNBQWMsQ0FBQyxNQUFmLENBQXNCLFdBQXRCLEVBQW1DLGdCQUFuQztBQUNIIiwic291cmNlUm9vdCI6IiJ9